module.exports = __webpack_public_path__ + "static/media/07.63e7d1e1.png";